/**
 * Product commercial identity — SKU / EAN-GTIN validation (strings, preserve leading zeros).
 */

const SKU_RE = /^[A-Za-z0-9][A-Za-z0-9._\-]{0,63}$/;
/** Common retail lengths: UPC-A 12, EAN-13 13, GTIN-14 14; also allow EAN-8. */
const EAN_RE = /^\d{8}$|^\d{12,14}$/;

export function normalizeSku(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  return s;
}

export function normalizeEan(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  // Preserve leading zeros — never Number()
  const s = String(raw).trim().replace(/\s+/g, "");
  if (!s) return null;
  return s;
}

export function validateSku(raw: string | null | undefined): { ok: true; value: string | null } | { ok: false; error: string } {
  const value = normalizeSku(raw);
  if (value == null) return { ok: true, value: null };
  if (!SKU_RE.test(value)) {
    return { ok: false, error: "SKU inválido. Usá letras, números, guiones, puntos o guión bajo (máx. 64)." };
  }
  return { ok: true, value };
}

export function validateEan(raw: string | null | undefined): { ok: true; value: string | null } | { ok: false; error: string } {
  const value = normalizeEan(raw);
  if (value == null) return { ok: true, value: null };
  if (!EAN_RE.test(value)) {
    return { ok: false, error: "EAN/GTIN inválido. Debe tener 8, 12, 13 o 14 dígitos (se conservan ceros iniciales)." };
  }
  return { ok: true, value };
}
